import { Component, ComponentFactory, Label, Panel, PanelProps } from "@mcleod/components";
import { ArrayUtil, EmailUtil, GeneralSettings, ServerError, StringUtil } from "@mcleod/core";

export class ServerErrorPanel extends Panel {
    constructor(error: ServerError, props?: Partial<PanelProps>) {
        super(props);
        this.add(...this.createMessageLabels(error.messages));
        if (error.errorTag != null) {
            this.add(this.createErrorIdLabel(error.errorTag));
            this.addEmailSupportLabel(error.errorTag);
        }
    }

    private createMessageLabels(messages: string[]): Component[] {
        const finalizedMessages = ArrayUtil.getAsArray(messages, true).map(message => StringUtil.appendPeriod(message));
        return ComponentFactory.createMultipleCommon(finalizedMessages, { fontBold: true, fillRow: true, wrap: true });
    }

    private createErrorIdLabel(errorTag: string) {
        return new Label({ text: "Error ID: " + errorTag, marginTop: 15 });
    }

    private addEmailSupportLabel(errorTag: string) {
        const emailAddress = GeneralSettings.get()?.support_email_address;
        if (!EmailUtil.isValidEmail(emailAddress)) {
            return;
        }
        const link = `mailto:${emailAddress}?subject=Error report&body=Received error tag ${errorTag}.`;
        this.add(new Label({ text: "Email support", link }));
    }
}
